import {dynamic} from '@github-ui/dynamic'
import {withLazyAppBoundary} from '@github-ui/react-core/lazy-app-boundary'
import type {PullRequestsRouteComponents} from './create-pull-requests-routes'

export const lazyPullRequestsRouteComponents: PullRequestsRouteComponents = {
  PullRequestErrorState: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./route-components')
      return {default: module.PullRequestErrorState}
    }),
  ),
  LayoutEntrypoint: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./route-components')
      return {default: module.LayoutEntrypoint}
    }),
  ),
  CommitsEntrypoint: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./route-components')
      return {default: module.CommitsEntrypoint}
    }),
  ),
  CommitsWithRangeEntrypoint: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./route-components')
      return {default: module.CommitsWithRangeEntrypoint}
    }),
  ),
  ChangesEntrypoint: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./route-components')
      return {default: module.ChangesEntrypoint}
    }),
  ),
  ChangesWithRangeEntrypoint: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./route-components')
      return {default: module.ChangesWithRangeEntrypoint}
    }),
  ),
  ConversationsEntrypoint: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./route-components')
      return {default: module.ConversationsEntrypoint}
    }),
  ),
  ChecksEntrypoint: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./route-components')
      return {default: module.ChecksEntrypoint}
    }),
  ),
  OverviewIndexRouteEntrypoint: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./route-components')
      return {default: module.OverviewIndexRouteEntrypoint}
    }),
  ),
  OverviewRouteEntrypoint: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./route-components')
      return {default: module.OverviewRouteEntrypoint}
    }),
  ),
  FindingsEntrypoint: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./route-components')
      return {default: module.FindingsEntrypoint}
    }),
  ),
  ArtifactsEntrypoint: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./route-components')
      return {default: module.ArtifactsEntrypoint}
    }),
  ),
  RepoPullsDashboardContent: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./route-components')
      return {default: module.RepoPullsDashboardContent}
    }),
  ),
  RepoPullsDashboardLayout: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./route-components')
      return {default: module.RepoPullsDashboardLayout}
    }),
  ),
  RepoStacksList: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./route-components')
      return {default: module.RepoStacksList}
    }),
  ),
  RepoStackDetail: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./route-components')
      return {default: module.RepoStackDetail}
    }),
  ),
}
